import { RoomSetting } from "./RoomSettings";

export class ProjectSetting {

    public roomSetting: RoomSetting;

    constructor() {
        this.roomSetting = new RoomSetting();
    }
}